enum PaymentRemittancesGroupByType {
  COMPANY = 'COMPANY',
  METHOD = 'METHOD',
  BANK = 'BANK',
  SUPPLIER = 'SUPPLIER',
  NATURE = 'NATURE'
}

export default PaymentRemittancesGroupByType;
